"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("./DataObjectConverter");
/**
 * DataObjectConverter is basic interface that handles conversion between JSON
 * representation (e.g. WEB API or data store representation) and domain object of type T.
 *
 * @author PKr
 */


var DataObjectListConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(DataObjectListConverter, _DataObjectConverter_);

  function DataObjectListConverter() {
    _classCallCheck(this, DataObjectListConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataObjectListConverter).apply(this, arguments));
  }

  return DataObjectListConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.DataObjectListConverter = DataObjectListConverter;